module.exports = __webpack_public_path__ + "img/icon_heart_9.ea2e5583.svg";